import { useParams } from 'react-router-dom';
import { SharedDashboard } from '../../components/dashboards/SharedDashboard';

/**
 * Public route. Deliberately outside PrivateRoutes: a share link works for
 * someone with no Zafron account, which is the point of the feature.
 */
export default function SharedView() {
  const { token } = useParams();
  return <SharedDashboard token={token} />;
}
